import { Component, Inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DIALOG_DATA, DialogRef } from "@angular/cdk/dialog";
import { ConfirmationModalData } from "../../models/confirmation-modal-data.model";

/**
 * PURPOSE: provides a reusable confirmation modal with configurable title, message, and button text.
 */
@Component({
  selector: "app-confirmation-modal",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./confirmation-modal.component.html",
  styleUrl: "./confirmation-modal.component.scss"
})
export class ConfirmationModalComponent {
  constructor(
    public dialogRef: DialogRef<boolean>,
    @Inject(DIALOG_DATA) public data: ConfirmationModalData
  ) {}

  protected onConfirm(): void {
    this.dialogRef.close(true);
  }

  protected onCancel(): void {
    this.dialogRef.close(false);
  }
}
